import type { CircuitWithSteps, SignatureStep } from '../../services/signature/signatureService';
import { CircuitStatusBadge } from './circuitStatusBadge';
import { circuitKindBadgeLabel, parseCircuitKind } from '../../lib/signature/circuitKind';

import { formatAppDate } from '../../lib/dateFormat';
interface Props {
  circuit: CircuitWithSteps;
  myStep?: SignatureStep | null;
  onClick: () => void;
}

export function CircuitListRow({ circuit, myStep, onClick }: Props) {
  const dossierLabel = circuit.dossier ? `${circuit.dossier.title} — ${circuit.dossier.number}` : '—';
  const deadline = myStep?.deadline_at ? new Date(myStep.deadline_at) : null;
  const overdue = deadline && deadline < new Date();

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left flex items-center gap-3 px-4 py-3 border border-neutral-200 rounded-md hover:border-cime-primary/40 transition bg-white"
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium truncate text-cime-text-primary">{circuit.title}</span>
          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium bg-neutral-100 text-neutral-700">
            {circuitKindBadgeLabel(parseCircuitKind(circuit.kind))}
          </span>
          <CircuitStatusBadge
            status={circuit.status as 'draft' | 'in_progress' | 'awaiting_revision' | 'completed' | 'rejected' | 'cancelled'}
            size="sm"
            kind={circuit.kind}
          />
        </div>
        <div className="text-xs text-cime-text-muted truncate mt-0.5">
          {dossierLabel} · {circuit.file?.filename ?? '—'}
        </div>
      </div>
      {deadline && (
        <div className={`text-xs ${overdue ? 'text-red-700 font-medium' : 'text-amber-700'}`}>
          Éch. {formatAppDate(deadline, { year: false })}
        </div>
      )}
    </button>
  );
}
